<template >
  <div class="card-header dash-card-header row" style="min-height: 40px;">
    <div v-bind:class="{ 'row-txt-l': hasSalesKpi }" >{{ getKpiContactInitiationName }}</div>
    <div v-bind:class="{ 'row-txt-m': hasSalesKpi }">{{ getKpiLamborghiniCIName }}</div>
    <div v-bind:class="{ 'row-txt-r': hasSalesKpi }" style="display: flex; align-items: middle;">
      <div class="h-100 w-25">
        {{ getKpiSalesProcessName }}
      </div>
      <div class="h-100 w-25">
        <performanceitem  :overallByWave="getOverallByWave"
                          :kpi="getKpiSalesProcess" />
      </div>
    </div>
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      performanceitem
    },

    mixins: [ KpiMixin ],

    computed: {
      hasSalesKpi: function() {
        return (this.getKpiName('03. Sales Process') || this.getKpiName('03. Online Sales Process')) !== null;
      },

      getKpiSalesProcessName: function() {
        return (
          this.getKpiName('03. Sales Process') ||
          this.getKpiName('03. Online Sales Process')
        );
      },

      getKpiSalesProcess: function() {
        return (
          this.getKpiByString('03. Sales Process') ||
          this.getKpiByString('03. Online Sales Process')
        );
      },

      getKpiContactInitiationName: function() {
        return this.getKpiName('01. Contact Initiation');
      },

      getKpiLamborghiniCIName: function() {
        return (
          this.getKpiName('02. Lamborghini CI') ||
          this.getKpiName('02. Streaming Experience')
        );
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

.row-txt-l {
  height: 100%;
  width: 12.45%;
  font-weight: bold;
  text-align: center;
  border-right:solid 1px $lambo-header-border;
}
.row-txt-m{
  height: 100%;
  width: 12.45%;
  font-weight: bold;
  text-align: center;
  border-left:solid 1px $lambo-header-border;
  border-right:solid 1px $lambo-header-border;
}
.row-txt-r {
  height: 100%;
  flex-grow:1;
   font-weight: bold;
  text-align: center;
  background-color: $lambo-header-color-alt;
  border-left:solid 1px $lambo-header-border;
}

</style>
